// extracted by mini-css-extract-plugin
export var label = "_jb-0";
export var treatmentCard = "_jb-1";